import { PiWarningCircleBold } from 'react-icons/pi';
import { Button } from '../../../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../../../components/modal/modal';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useDishMenuStore } from '../../../../../../../../store/use-dish-menu-store';
import s from './menu-informer-uploaded-save-modal.module.css';

export const MenuInformerUploadedSaveModal = (props: ModalProps) => {
  const { t } = useLang();
  const { menuUploadConfirm, setUploadedMenu, isLoading } = useDishMenuStore();

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await menuUploadConfirm();
      setUploadedMenu(undefined);
      props.onClose();
      window.history.back();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      className={s.feature}
      title={
        <div className={s.label}>
          <span>
            <PiWarningCircleBold color="#D80027" size={24} />
          </span>
          {t(
            'Внимание, загружаемые данные перепишут существующее меню! Все предыдущие данные будут удалены!',
          )}
        </div>
      }
      {...props}
      onClose={() => props.onClose()}
    >
      <div className={s.controls}>
        <Button
          onClick={() => props.onClose()}
          disabled={isLoading}
          variant="secondary"
          size="lg"
          data-testid="cancel-button"
        >
          {t('Отмена')}
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={isLoading}
          variant="success"
          size="lg"
          data-testid="submit-button"
        >
          {t('Подтвердить перезапись данных')}
        </Button>
      </div>
    </Modal>
  );
};
